export class WpProductoDto {
    public id: number = 0;
    public name: string = "";
    public status: string = "";
    public permalink: string = "";
    public regular_price: string = "";
    public sale_price: string = "";
    public price: string = "";
    public stock_status: string = "";
    public stock_quantity: number = 0;
    public categories: Array<{ id: number; name: string }> = [];
    public images: Array<{ src: string }> = [];
    public date_created: string = "";
    public sku: string = "";
    public description: string = "";
    public short_description: string = "";

    constructor(data?: any) {
        if (!data) return;
        this.id                = data.id || 0;
        this.name              = data.name || "";
        this.status            = data.status || "";
        this.permalink         = data.permalink || "";
        this.regular_price     = data.regular_price || "";
        this.sale_price        = data.sale_price || "";
        this.price             = data.price || "";
        this.stock_status      = data.stock_status || "";
        this.stock_quantity    = data.stock_quantity || 0;
        this.categories        = data.categories || [];
        this.images            = data.images || [];
        this.date_created      = data.date_created || "";
        this.sku               = data.sku || "";
        this.description       = data.description || "";
        this.short_description = data.short_description || "";
    }

    get imagenPrincipal(): string {
        return this.images && this.images.length > 0 ? this.images[0].src : "";
    }

    get categoriaNombre(): string {
        return this.categories && this.categories.length > 0
            ? this.categories.map((c) => c.name).join(", ")
            : "—";
    }
}
